import React from 'react';

import './styles.scss';
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

const InputSearch = ({ buscar, buscaPor }) => {

    return (
        <TextField
            className="search"
            fullWidth
            id="standard-bare"
            variant="outlined"
            label="Pesquisar"
            size="small"
            value={buscaPor}
            onChange={(e) => buscar(e.target.value)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <SearchIcon className="color-icon" />
                    </InputAdornment>
                )
            }}
        />);
}

export default InputSearch;